module.exports = "https://static.wanderu.com/ui-react/_next/static/media/phone-with-qr2x.035bb740.png";